import { BrowserRouter } from 'react-router';
import { AppProviders } from './AppProviders';
import { AppRouter } from './Router';

export function App() {
  return (
    <BrowserRouter>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </BrowserRouter>
  );
}
